<template>
  <div class="py-px">
    <button
      type="button"
      class="btn btn-tertiary h-full"
      @click="$router.back()"
    >
      <ArrowLeft class="btn-icon-left" />
      Back
    </button>
  </div>
</template>

<script>
import ArrowLeft from '@/assets/svg/icons/arrow-left.svg?inline'

export default {
  components: { ArrowLeft },
}
</script>
